import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-district',
  standalone: true,
  imports: [
    CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
    FormsModule, // ✅ for [(ngModel)]
    ReactiveFormsModule, // ✅ for reactive forms
  ],
  templateUrl: './add-district.component.html',
  styleUrls: ['./add-district.component.scss'],
})
export class AddDistrictComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';

  districtForm: UntypedFormGroup;

  showAdd = false;
  showEdit = false;
  id: any;

  degreeType: any;
  showErr = false;
  deleteErr: any;
  district: any;

  error_messages = {
    districtName: [{ type: 'required', message: 'Please enter district name' }],
  };
  districtValue: any;
  adminName: any;
  adminImage: any;
  allDistrict: any;
  allData: any;

  showData = false;
  showNodata = false;

  searchval: any;
  disrictData: any;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.districtForm = this.formBuilder.group({
      districtName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;
    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    const servicePathDistrict = this.utils.getApiConfigs('district');
    this.commonservice
      .invokeService(
        servicePathDistrict[1].method,
        servicePathDistrict[1].path,
        ''
      )
      .then((resp: any) => {
        // console.log("District", resp);
        if (resp.status_code == '200') {
          this.disrictData = resp.data;
          // console.log("district", this.disrictData);

          if (this.disrictData == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        }
        this.districtValue = this.disrictData;
      });
  }

  onChangeEvent(event) {
    var val = event.target.value;
    this.allData = this.disrictData;

    if (val) {
      this.districtValue = this.allData.filter((item) =>
        item.district.toLowerCase().includes(val.toLowerCase())
      );
    }

    if (this.districtValue == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
    this.ngOnInit();
  }

  openAdd() {
    this.districtForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  addDistrict() {
    this.spinner.show();
    let payload = {
      district: this.district,
    };
    const servicePath = this.utils.getApiConfigs('district');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.globalService.showSuccess('District added successfully');
          this.display = 'none';
          this.ngOnInit();
          this.districtForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
      });
  }

  deleteCountry(data) {
    // console.log("data");
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletedistrict');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('District deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.message);
          this.deleteErr = resp.message;
          this.showErr = true;
        }
      });
  }
}
